import { createRootRoute, Outlet } from "@tanstack/react-router";
import { useSettingsStore } from "@/store/settingsStore";

function RootLayout() {
  const accessibility = useSettingsStore((state) => state.accessibility);

  return (
    <div
      class={[
        "min-h-dvh bg-ink text-parchment",
        accessibility.largeText ? "text-lg" : "text-base",
        accessibility.highContrast ? "contrast-125 saturate-150" : "",
      ].join(" ")}
    >
      <Outlet />
    </div>
  );
}

export const Route = createRootRoute({ component: RootLayout });
